<div class="aca-admin aca-set">
  <aca-page-header icon="settings" [title]="'DMS.SETTINGS.79B566' | translate" [subtitle]="'DMS.UI.023EB7' | translate" />

  <div class="aca-set__body">
    <!-- ── categories ───────────────────────────────────────────────────── -->
    <nav class="aca-set__nav" [attr.aria-label]="'DMS.SETTINGS.DACD57' | translate">
      <h3 class="aca-set__navtitle">{{ 'DMS.SETTINGS.DACD57' | translate }}</h3>
      <button
        type="button"
        class="aca-set__navitem"
        *ngFor="let section of visibleSections()"
        [class.aca-set__navitem--on]="active === section.id"
        [attr.aria-current]="active === section.id ? 'true' : null"
        (click)="select(section.id)"
      >
        <span class="aca-set__navicon"
          ><mat-icon>{{ section.icon }}</mat-icon></span
        >
        <span class="aca-set__navtext">
          <span class="aca-set__navlabel">{{ section.title | translate }}</span>
          <span class="aca-set__navdesc">{{ section.description | translate }}</span>
        </span>
      </button>
    </nav>

    <!-- ── panels ───────────────────────────────────────────────────────── -->
    <div class="aca-set__panels">
      <!-- administration: the way in to the screens the navigation used to
           carry as a submenu under "การตั้งค่า" -->
      <!-- the tools open here rather than on routes of their own, so choosing
           one never takes the category rail away -->
      <section class="aca-set__card" *ngIf="active === 'admin' && !openTool()">
        <h3 class="aca-set__cardtitle">{{ 'DMS.UI.091FB6' | translate }}</h3>
        <p class="aca-set__cardnote">{{ 'DMS.UI.0A9E86' | translate }}</p>

        <div class="aca-set__tools">
          <button type="button" class="aca-set__tool" *ngFor="let tool of adminTools" (click)="showTool(tool)">
            <span class="aca-set__toolicon"
              ><mat-icon>{{ tool.icon }}</mat-icon></span
            >
            <span class="aca-set__tooltext">
              <span class="aca-set__toollabel">{{ tool.title | translate }}</span>
              <span class="aca-set__tooldesc">{{ tool.description | translate }}</span>
            </span>
            <mat-icon class="aca-set__toolgo">chevron_right</mat-icon>
          </button>
        </div>
      </section>

      <section class="aca-set__card aca-set__card--flush" *ngIf="active === 'admin' && openTool() as tool">
        <div class="aca-set__toolbar">
          <button type="button" class="aca-set__back" (click)="closeTool()"><mat-icon>arrow_back</mat-icon>{{ 'DMS.UI.091FB6' | translate }}</button>
          <span class="aca-set__toolnow"
            ><mat-icon>{{ tool.icon }}</mat-icon
            >{{ tool.title | translate }}</span
          >
        </div>

        <app-users-page *ngIf="tool.id === 'users'" [embedded]="true" />
        <app-groups-page *ngIf="tool.id === 'groups'" [embedded]="true" />
        <app-audit-log *ngIf="tool.id === 'audit'" [embedded]="true" />
        <app-pdpa-report *ngIf="tool.id === 'pdpa'" [embedded]="true" />
        <!-- the caveat about this deployment, said in one line: the detail is
             only of interest to whoever administers the server, so it waits in
             the tooltip rather than taking a paragraph of the panel -->
        <p class="aca-set__status" *ngIf="tool.id === 'mail'">
          <span class="aca-set__statusdot"></span>
          <span>{{ 'DMS.SETTINGS.MAIL_STATUS' | translate }}</span>
          <strong class="aca-set__statusvalue">{{ mailChannel() | translate }}</strong>
          <span>· {{ 'DMS.SETTINGS.MAIL_SMTP' | translate }}</span>
          <strong class="aca-set__statusvalue" *ngIf="smtpState() as smtp">{{ 'DMS.SETTINGS.MAIL_SMTP_' + (smtp | uppercase) | translate }}</strong>
          <mat-icon
            class="aca-set__statuswhy"
            [matTooltip]="'DMS.SETTINGS.MAIL_STATUS_WHY' | translate"
            matTooltipPosition="below"
            matTooltipClass="aca-set__statustip"
            >help_outline</mat-icon
          >
        </p>
        <app-email-templates *ngIf="tool.id === 'mail'" [embedded]="true" />
        <app-watermark-settings *ngIf="tool.id === 'watermark'" [embedded]="true" />
        <app-menu-permissions *ngIf="tool.id === 'menuPerms'" [embedded]="true" />
        <app-jobs-page *ngIf="tool.id === 'jobs'" [embedded]="true" />
        <app-signing-settings *ngIf="tool.id === 'signing'" />
      </section>

      <!-- profile -->
      <section class="aca-set__card" *ngIf="active === 'profile'">
        <h3 class="aca-set__cardtitle">{{ 'DMS.SETTINGS.D7B26E' | translate }}</h3>
        <div class="aca-set__profile" *ngIf="person() as user">
          <dl class="aca-set__props">
            <dt>{{ 'DMS.SETTINGS.7F4210' | translate }}</dt>
            <dd>{{ user.id }}</dd>

            <dt>{{ 'DMS.SETTINGS.8846FC' | translate }}</dt>
            <dd>{{ user.displayName }}</dd>

            <dt>{{ 'DMS.SETTINGS.6CF08C' | translate }}</dt>
            <dd>{{ user.email }}</dd>

            <dt>{{ 'DMS.SETTINGS.EE4A25' | translate }}</dt>
            <dd>{{ user.jobTitle }}</dd>

            <dt>{{ 'DMS.SETTINGS.485E68' | translate }}</dt>
            <dd>
              <select
                class="aca-set__select"
                [ngModel]="language"
                (ngModelChange)="changeLanguage($event)"
                [attr.aria-label]="'DMS.SETTINGS.485E68' | translate"
              >
                <option *ngFor="let option of languages" [value]="option.key">{{ option.label | translate }}</option>
              </select>
            </dd>

            <dt>{{ 'DMS.SETTINGS.BE1D1F' | translate }}</dt>
            <dd>
              {{ timezone }}
              <span class="aca-set__hint">{{ 'DMS.SETTINGS.CD9C39' | translate }}</span>
            </dd>

            <dt>{{ 'DMS.SETTINGS.AE19D2' | translate }}</dt>
            <dd>
              <span class="aca-set__chip" [ngClass]="user.enabled ? 'aca-set__chip--on' : 'aca-set__chip--off'">
                {{ (user.enabled ? 'DMS.UI.216768' : 'DMS.UI.65B98F') | translate }}
              </span>
            </dd>
          </dl>

          <div class="aca-set__avatarbox">
            <img *ngIf="avatarUrl(); else initials" class="aca-set__avatarimg" [src]="avatarUrl()" [alt]="user.displayName" />
            <ng-template #initials
              ><span class="aca-set__avatar">{{ initial(user.displayName) }}</span></ng-template
            >

            <p class="aca-set__hint">{{ 'DMS.SETTINGS.AVATAR_HINT' | translate }}</p>

            <!-- the input is the control; the button is what anyone actually sees -->
            <input
              #avatarInput
              type="file"
              class="aca-set__file"
              accept="image/png,image/jpeg,image/gif,image/webp"
              (change)="uploadAvatar($event)"
              [attr.aria-label]="'DMS.SETTINGS.AVATAR_UPLOAD' | translate"
            />
            <button type="button" class="aca-set__outline" [disabled]="avatarBusy()" (click)="avatarInput.click()">
              <mat-icon>photo_camera</mat-icon>{{ 'DMS.SETTINGS.AVATAR_UPLOAD' | translate }}
            </button>
            <button type="button" class="aca-set__linkbtn" *ngIf="avatarUrl()" [disabled]="avatarBusy()" (click)="removeAvatar()">
              {{ 'DMS.SETTINGS.AVATAR_REMOVE' | translate }}
            </button>
          </div>
        </div>
      </section>

      <!-- usage -->
      <section class="aca-set__card" *ngIf="active === 'usage'">
        <h3 class="aca-set__cardtitle">{{ 'DMS.SETTINGS.1BC0AC' | translate }}</h3>
        <p class="aca-set__cardnote">{{ 'DMS.SETTINGS.0B04DC' | translate }}</p>

        <label class="aca-set__row">
          <span class="aca-set__rowlabel"
            >{{ 'DMS.SETTINGS.26E83F' | translate }}<span class="aca-set__rowhint">{{ 'DMS.SETTINGS.5E5F86' | translate }}</span>
          </span>
          <select class="aca-set__select" [ngModel]="landing" (ngModelChange)="saveLanding($event)">
            <option *ngFor="let option of landings" [value]="option.value">{{ option.label | translate }}</option>
          </select>
        </label>

        <label class="aca-set__row">
          <span class="aca-set__rowlabel"
            >{{ 'DMS.SETTINGS.ED2258' | translate }}<span class="aca-set__rowhint">{{ 'DMS.SETTINGS.8BCF28' | translate }}</span>
          </span>
          <select class="aca-set__select" [ngModel]="pageSize" (ngModelChange)="savePageSize($event)">
            <option *ngFor="let size of pageSizes" [value]="size">{{ size }} {{ 'DMS.UI.4514CB' | translate }}</option>
          </select>
        </label>

        <div class="aca-set__row">
          <span class="aca-set__rowlabel"
            >{{ 'DMS.SETTINGS.ACD533' | translate }}<span class="aca-set__rowhint">{{ 'DMS.SETTINGS.DC2E8B' | translate }}</span>
          </span>
          <mat-slide-toggle [checked]="theme.isDark()" (change)="toggleTheme()" [attr.aria-label]="'DMS.SETTINGS.ACD533' | translate" />
        </div>
      </section>

      <!-- branding: same kind of setting as usage, so it lives in this
           category rather than having a rail entry of its own -->
      <section class="aca-set__card" *ngIf="active === 'usage'">
        <h3 class="aca-set__cardtitle">Branding</h3>
        <p class="aca-set__cardnote">
          {{ (person()?.isAdmin ? 'DMS.SETTINGS.BRAND_NOTE_ADMIN' : 'DMS.SETTINGS.BRAND_NOTE') | translate }}
        </p>

        <dl class="aca-set__props">
          <dt>{{ 'DMS.SETTINGS.EDC0A9' | translate }}</dt>
          <dd>
            <input
              *ngIf="person()?.isAdmin; else nameOnly"
              class="aca-set__input"
              type="text"
              [(ngModel)]="brandName"
              maxlength="60"
              [attr.aria-label]="'DMS.SETTINGS.EDC0A9' | translate"
            />
            <ng-template #nameOnly>{{ branding.name() }}</ng-template>
          </dd>

          <dt>{{ 'DMS.SETTINGS.9156EF' | translate }}</dt>
          <dd>
            <img class="aca-set__logo" [src]="brandLogo || branding.logo()" [alt]="branding.name()" />
            <div class="aca-set__logoactions" *ngIf="person()?.isAdmin">
              <input
                #logoInput
                type="file"
                class="aca-set__file"
                accept="image/png,image/jpeg,image/svg+xml,image/webp"
                (change)="pickLogo($event)"
                [attr.aria-label]="'DMS.SETTINGS.BRAND_LOGO_PICK' | translate"
              />
              <button type="button" class="aca-set__outline" (click)="logoInput.click()">
                <mat-icon>image</mat-icon>{{ 'DMS.SETTINGS.BRAND_LOGO_PICK' | translate }}
              </button>
              <button type="button" class="aca-set__linkbtn" (click)="resetLogo()">{{ 'DMS.SETTINGS.BRAND_LOGO_RESET' | translate }}</button>
            </div>
          </dd>

          <dt>{{ 'DMS.SETTINGS.ED7673' | translate }}</dt>
          <dd>
            <ng-container *ngIf="person()?.isAdmin; else colourOnly">
              <div class="aca-set__swatches">
                <button
                  type="button"
                  class="aca-set__swatchbtn"
                  *ngFor="let preset of colourPresets"
                  [class.aca-set__swatchbtn--on]="brandPrimary === preset"
                  [style.background]="preset"
                  [attr.aria-label]="preset"
                  [attr.aria-pressed]="brandPrimary === preset"
                  (click)="brandPrimary = preset"
                ></button>
              </div>

              <label class="aca-set__colourpick">
                <input type="color" [(ngModel)]="brandPrimary" [attr.aria-label]="'DMS.SETTINGS.BRAND_COLOUR_PICK' | translate" />
                <span>{{ 'DMS.SETTINGS.BRAND_COLOUR_PICK' | translate }}</span>
                <code>{{ brandPrimary }}</code>
              </label>
            </ng-container>

            <ng-template #colourOnly>
              <span class="aca-set__colour"><span class="aca-set__swatch"></span>{{ branding.primary() || defaultPrimary }}</span>
            </ng-template>
          </dd>

          <dt>{{ 'DMS.SETTINGS.4C65C9' | translate }}</dt>
          <dd>{{ appVersion || '—' }}</dd>
        </dl>

        <div class="aca-set__actions" *ngIf="person()?.isAdmin">
          <button type="button" class="aca-set__save" [disabled]="brandBusy()" (click)="saveBranding()">
            {{ 'DMS.SETTINGS.BRAND_SAVE' | translate }}
          </button>
        </div>
      </section>

      <!-- system: read-only repository facts, shown under the same category -->
      <section class="aca-set__card" *ngIf="active === 'usage'">
        <h3 class="aca-set__cardtitle">{{ 'DMS.SETTINGS.E1A4DB' | translate }}</h3>
        <p class="aca-set__cardnote">{{ 'DMS.SETTINGS.522FEF' | translate }}</p>

        <dl class="aca-set__props" *ngIf="repository() as repo">
          <dt>{{ 'DMS.SETTINGS.4F36C6' | translate }}</dt>
          <dd>{{ repo.edition }}</dd>

          <dt>{{ 'DMS.SETTINGS.9A0D5E' | translate }}</dt>
          <dd>{{ repo.version }}</dd>

          <dt>{{ 'DMS.SETTINGS.FE1F70' | translate }}</dt>
          <dd>{{ repo.modules }} {{ 'DMS.UI.FFBCFF' | translate }}</dd>

          <dt>{{ 'DMS.SETTINGS.8018AA' | translate }}</dt>
          <dd>
            <span class="aca-set__chip" [ngClass]="repo.readOnly ? 'aca-set__chip--off' : 'aca-set__chip--on'">
              {{ (repo.readOnly ? 'DMS.UI.390C8E' : 'DMS.UI.3B76B6') | translate }}
            </span>
          </dd>

          <dt>{{ 'DMS.SETTINGS.F7C20F' | translate }}</dt>
          <dd>
            <span class="aca-set__chip" [ngClass]="repo.auditEnabled ? 'aca-set__chip--on' : 'aca-set__chip--off'">
              {{ (repo.auditEnabled ? 'DMS.UI.098289' : 'DMS.UI.1B6D61') | translate }}
            </span>
          </dd>
        </dl>
      </section>

      <!-- metadata fields: the schema, and the values each list field allows -->
      <section class="aca-set__card aca-set__card--flush" *ngIf="active === 'fields'">
        <app-metadata-fields [embedded]="true" />
      </section>

      <!-- retention -->
      <!-- the expiry screen itself, not a summary of it: this category is where
           retention is managed, so the whole thing lives here rather than
           sending anyone to a separate page for the actual work -->
      <section class="aca-set__card aca-set__card--flush" *ngIf="active === 'retention'">
        <app-document-expiry [embedded]="true" />
      </section>

      <!-- workflow: the administrator's switch for the feature, and the
           builder it used to sit beside under administration -->
      <section class="aca-set__card" *ngIf="active === 'workflow'">
        <h3 class="aca-set__cardtitle">{{ 'DMS.WORKFLOW.TITLE' | translate }}</h3>
        <p class="aca-set__cardnote">{{ 'DMS.WORKFLOW.SECTION_NOTE' | translate }}</p>

        <div class="aca-set__row">
          <span class="aca-set__rowlabel"
            >{{ 'DMS.WORKFLOW.ENABLED' | translate }}<span class="aca-set__rowhint">{{ 'DMS.WORKFLOW.ENABLED_HINT' | translate }}</span>
          </span>
          <mat-slide-toggle
            [checked]="workflowSettings.enabled()"
            (change)="saveWorkflowEnabled($event.checked)"
            [disabled]="workflowBusy()"
            [attr.aria-label]="'DMS.WORKFLOW.ENABLED' | translate"
          />
        </div>
      </section>

      <!-- the catalogue itself, not a link to it — workflow management lives
           inside settings, the same way every other admin tool does. Its
           create/edit actions open the designer at /build-workflow, so the
           builder is not embedded again here — that painted a second,
           competing template list under the catalogue -->
      <section class="aca-set__card aca-set__card--flush" *ngIf="active === 'workflow'">
        <app-workflow-manage [embedded]="true" />
      </section>

      <!-- data migration: the center owns its own sub-navigation and URLs -->
      <section class="aca-set__card aca-set__card--flush" *ngIf="active === 'migration'">
        <app-migration-center />
      </section>

      <!-- the AI assistant -->
      <section class="aca-set__card" *ngIf="active === 'assistant'">
        <app-assistant-settings />
      </section>
    </div>
  </div>
</div>
